<template>
  <Header />
  <div v-if="login">
    <component 
      v-for="(paragraaf, index) in paragrafen" 
      :key="'paragraaf-' + index" 
      :is="paragraaf.type[0].titel"
      :credits="credits"
      :content="paragraaf">
    </component>
  </div>
</template>

<script>
  import Header from './components/header/Header.vue';
  import Chat from './components/chat/user.vue';
  import Operator from './components/chat/operator.vue';
  import Tekst from './components/Tekst.vue'; 
  import Credits from './components/buy-credits.vue'
  import Wissel from './components/Wissel.vue';
  import Colofon from './components/colofon.vue';
  import Handleiding from './components/handleiding.vue';
  import Logboek from './components/logboek.vue';

export default {
  name: 'App',
  computed: {
    login () {
      return this.$store.state.login;
    },

    match () {
      return this.$store.state.login;
    },

    paragrafen() {
      return this.$store.state.content.paragrafen;
    },

    credits() {
      return this.$store.state.credits;
    }    
  }, 
  components: {
    Header,
    Chat,
    Tekst,
    Credits,
    Wissel,
    Operator,
    Colofon,
    Handleiding,
    Logboek
  }
}
</script>

<style lang="scss" scoped>
  .knd-overlay {
    position: relative;
    background: #DEFF9C;
    z-index:100;
    width: 100% !important;
  }

  .knd-fixed {
    height: 100vh;
  }

</style>